import { render, staticRenderFns } from "./termDialog.vue?vue&type=template&id=5b1040d7&scoped=true&"
import script from "./termDialog.vue?vue&type=script&lang=js&"
export * from "./termDialog.vue?vue&type=script&lang=js&"
import style0 from "./termDialog.vue?vue&type=style&index=0&id=5b1040d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1040d7",
  null
  
)

export default component.exports